import React, { useState, useEffect, useRef } from 'react'
import { Card, Tabs } from 'antd'
import dayjs from 'dayjs'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { formatMessageNew, downLoadFileBlob, paginationInit, formatStartTime, formatEndTime } from '@/utils/common'
import { getTunnelReport, rfidAbnormalReport } from '@/services/Email/RFIDDailyReport'
import SearchBar from '@/components/searchbar/SearchBar'
import AntdTable from '@/components/table/AntdTable'
import ActionBar from '@/components/table/ActionBar'
const dateFormat = 'YYYY-MM-DD'
const startMonth = dayjs().subtract(6, 'day')
const endMonth = dayjs()
const RFIDAbnormalReport = () => {
  let formRef = useRef(null)
  const mounting = useRef(false)
  const languageState = useSelector(state => state.commonStore.language)
  const deviceSize = useSelector(state => state.commonStore.deviceSize)
  const [queryFlag, setQueryFlag] = useState(false)
  const [settingSize, setSettingSize] = useState(20)
  // Scan Info
  const [tabActive, setTabActive] = useState('3')
  // Abnormal Tunnel Status
  const [tunnelPagination, setTunnelPagination] = useState(paginationInit)
  const [tunnelStatusData, setTunnelStatusData] = useState([])
  // Abnormal Tunnel Heartbeat Status
  const [heartbeatPagination, setHeartbeatPagination] = useState(paginationInit)
  const [heartbeatData, setHeartbeatData] = useState([])

  let searchListInit = [
    {
      type: 'timeRange',
      label: 'languageObj.emailRfidDailyReport.searchDateTitle',
      key: 'rangeDate',
      format: dateFormat,
      disabledDate: current => {
        let falg = current && current > moment().endOf('day')
        return falg
      },
      initialValues: [startMonth, endMonth],
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]
  const tableColumnsTunnelStatus = [
    {
      title: formatMessageNew('languageObj.emailRfidDailyReport.tunnelMachine'),
      dataIndex: 'deviceCode',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailRfidDailyReport.statusCode'),
      dataIndex: 'statusCode',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailRfidDailyReport.statusMessage'),
      dataIndex: 'statusMessage',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailRfidDailyReport.duration'),
      dataIndex: 'period',
      width: '120px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    }
  ]
  const tableColumnsTunnelHeartbeatStatus = [
    {
      title: formatMessageNew('languageObj.emailRfidDailyReport.tunnelMachine'),
      dataIndex: 'deviceCode',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailRfidDailyReport.statusCode'),
      dataIndex: 'statusCode',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.emailRfidDailyReport.duration'),
      dataIndex: 'period',
      width: '100px',
      render: text => {
        return <div className="word_break_word">{text}</div>
      }
    }
  ]

  useEffect(() => {
    setSettingSize(20 * deviceSize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceSize])

  useEffect(() => {
    if (mounting.current) {
      if (tabActive === '3') {
        getTunnelData()
      } else {
        getHeartbeatData()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])

  const searchDataBtn = () => {
    mounting.current = true
    if (tabActive === '3') {
      const pg = {
        ...tunnelPagination,
        currentPage: 1
      }
      setTunnelPagination(pg)
      setQueryFlag(!queryFlag)
    } else {
      const pg = {
        ...heartbeatPagination,
        currentPage: 1
      }
      setHeartbeatPagination(pg)
      setQueryFlag(!queryFlag)
    }
  }
  const searchClearDataBtn = () => {
    // formRef && formRef.current.clearForm()
    // formRef && formRef.current.setValue({ rangeDate: [] })
    if (tabActive === '3') {
      const pg = {
        ...tunnelPagination,
        currentPage: 1
      }
      setTunnelPagination(pg)
    } else {
      const pg = {
        ...heartbeatPagination,
        currentPage: 1
      }
      setHeartbeatPagination(pg)
    }
    setQueryFlag(!queryFlag)
  }

  const getParams = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { rangeDate } = info
    const params = {
      startDate: formatStartTime(rangeDate),
      endDate: formatEndTime(rangeDate)
    }
    return params
  }
  // Abnormal Tunnel Status
  const getTunnelData = () => {
    const { currentPage, pageSize } = tunnelPagination
    const params = {
      pageNo: currentPage,
      size: pageSize,
      ...getParams()
    }
    getTunnelReport('status', params).then(res => {
      const dt = res.resultData
      setTunnelStatusData(dt.records)
      setTunnelPagination({ ...tunnelPagination, total: dt.total })
    })
  }

  const tunnelStatusTableChange = pagination => {
    const params = {
      ...tunnelPagination,
      currentPage: pagination.current,
      pageSize: pagination.pageSize
    }
    setTunnelPagination({ ...params })
    setQueryFlag(!queryFlag)
  }

  const heartbeatTableChange = pagination => {
    const params = {
      ...heartbeatPagination,
      currentPage: pagination.current,
      pageSize: pagination.pageSize
    }
    setHeartbeatPagination({ ...params })
    setQueryFlag(!queryFlag)
  }
  // Abnormal Tunnel Heartbeat Status
  const getHeartbeatData = () => {
    const { currentPage, pageSize } = heartbeatPagination
    const params = {
      pageNo: currentPage,
      size: pageSize,
      ...getParams()
    }
    getTunnelReport('heartbeat', params).then(res => {
      const dt = res.resultData
      setHeartbeatData(dt.records)
      setHeartbeatPagination({ ...heartbeatPagination, total: dt.total })
    })
  }

  const downLoadFun = () => {
    const params = {
      isChinese: languageState === 'zh_CN' ? true : false,
      ...getParams()
    }
    let reportType = tabActive === '3' ? 'status' : 'heartbeat'
    rfidAbnormalReport(reportType, params).then(res => {
      downLoadFileBlob(res)
    })
  }
  const tabChange = e => {
    console.log(e)
    setTabActive(e)
  }
  const tabItems = [
    {
      key: '3',
      label: formatMessageNew('languageObj.emailRfidDailyReport.abnormalTunnelStatusTab'),
      children: (
        <AntdTable
          title={() => (
            <div className="fwb mt5 mb5">
              {formatMessageNew('languageObj.emailRfidDailyReport.abnormalTunnelStatus')}
            </div>
          )}
          dataSource={tunnelStatusData}
          columns={tableColumnsTunnelStatus}
          pagination={tunnelPagination}
          onChange={tunnelStatusTableChange}
        />
      )
    },
    {
      key: '4',
      label: formatMessageNew('languageObj.emailRfidDailyReport.abnormalTunnelHeartbeatStatusTab'),
      children: (
        <div>
          <AntdTable
            title={() => (
              <div className="fwb mt5 mb5">
                {formatMessageNew('languageObj.emailRfidDailyReport.abnormalTunnelHeartbeatStatus')}
              </div>
            )}
            dataSource={heartbeatData}
            columns={tableColumnsTunnelHeartbeatStatus}
            pagination={heartbeatPagination}
            onChange={heartbeatTableChange}
          />
          <div className="mt10 fontS14 color333">
            <div>{formatMessageNew('languageObj.emailRfidDailyReport.statusCode11')}</div>
            <div>{formatMessageNew('languageObj.emailRfidDailyReport.statusCode12')}</div>
          </div>
        </div>
      )
    }
  ]

  return (
    <div>
      <Card bordered={false}>
        <div>
          <div className="tagTypeVal" style={{ fontSize: settingSize }}>
            {formatMessageNew('languageObj.emailRfidDailyReport.reportTitle')}
          </div>
          <div className="search-bar" style={{ paddingLeft: 0 }}>
            <SearchBar
              ref={formRef}
              layout={{
                // labelCol: { span: 4 },
                wrapperCol: { span: 16 }
              }}
              searchList={searchListInit}
              showCollapseBtn={false}
              showSearchBtn={true}
              showClearBtn={true}
              onSearch={searchDataBtn}
              onClear={searchClearDataBtn}
            />
          </div>
        </div>
        <Tabs
          activeKey={tabActive}
          onChange={tabChange}
          items={tabItems}
          tabBarExtraContent={
            <ActionBar
              onDownload={downLoadFun}
              style={{ alignItems: 'end', paddingRight: 0, paddingBottom: 0 }}
            ></ActionBar>
          }
        />
      </Card>
    </div>
  )
}
export default RFIDAbnormalReport
